import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import * as styles from "./FooterLinksList.styles";
export var FooterLinksList = function FooterLinksList(_ref) {
  var links = _ref.links,
    sectionTitle = _ref.sectionTitle;
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  var getTrackingEventWithLabel = function getTrackingEventWithLabel(ev) {
    var _ev$currentTarget$tex;
    return {
      event: 'custom_event',
      event_category: 'Footer',
      event_action: "".concat(sectionTitle, " click"),
      event_label: (_ev$currentTarget$tex = ev.currentTarget.textContent) === null || _ev$currentTarget$tex === void 0 ? void 0 : _ev$currentTarget$tex.trim()
    };
  };
  return /*#__PURE__*/React.createElement(_StyledUl, {
    $_css: styles.list
  }, links.map(function (link) {
    var _link$target;
    return /*#__PURE__*/React.createElement(_StyledLi, {
      key: link.text,
      $_css2: styles.item
    }, /*#__PURE__*/React.createElement(_StyledA, _extends({
      href: link.url,
      onClick: trackLinkClick(getTrackingEventWithLabel),
      onMouseDown: trackLinkMouseDown(getTrackingEventWithLabel),
      target: (_link$target = link.target) !== null && _link$target !== void 0 ? _link$target : '_self'
    }, link.rel && {
      rel: link.rel
    }, {
      $_css3: styles.link
    }), link.text));
  }));
};
var _StyledUl = _styled("ul")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledLi = _styled2("li")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledA = /*#__PURE__*/_styled3("a").withConfig({
  displayName: "FooterLinksList___StyledA",
  componentId: "sc-1heacpe-0"
})(["", ""], function (p) {
  return p.$_css3;
});